import $ from 'jquery';
import _ from 'underscore';

function scrollByElement($element) {
  const $e = $($element);

  if (!$e || $e.length < 1) {
    return;
  }

  const ele = $e[0];

  if (_.isFunction(ele.scrollIntoView)) {
    ele.scrollIntoView(false);
  }
}

export function scrollTo($element) {
  scrollByElement($element);

  let $e = $($element);
  let $nav = $('.navbar-fixed-top');

  if (!$e || $e.length < 1 || !$nav || $nav.length < 1) {
    return;
  }

  let offset = $e.offset();

  if (!offset) {
    return;
  }

  let navBarHeight = $nav.css('position') === 'absolute' ? 0 : $nav.outerHeight();
  let top = offset.top - navBarHeight;
  let newTop = top < 0 ? 0 : top;

  window.scrollTo(0, newTop);
}

export function scrollAndCenter($element) {
  scrollByElement($element);

  let el = $($element);

  if (el && el.length >= 1) {
    let elOffsetTop = el.offset().top;
    let elHeight = el.height();
    let windowHeight = $(window).height();
    let offset;

    if (elHeight < windowHeight) {
      offset = elOffsetTop - ((windowHeight / 2) - (elHeight / 2));
    } else {
      offset = elOffsetTop;
    }

    window.scrollTo(0, offset);
  } else {
    window.scrollTo(0, 0);
  }
}
